module.exports = __webpack_public_path__ + "static/img/banner.9e0e84a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_1/banner.jpg
// module id = eR94
// module chunks = 0